import React from "react";
import { Route } from "react-router-dom";
import FinishLine from "../../components/geriactive/games/finishLine/FinishLine";
import QuizShow from "../../components/geriactive/games/quizShow/QuizShow";
import CategorySorts from "../../components/geriactive/games/categorySorts/CategorySorts";
import HighLow from "../../components/geriactive/games/highlow/HighLow";
import Games from "../../components/geriactive/games/Games";
import WordHunter from "../../components/geriactive/games/wordHunter/WordHunter";
import WordOfTheDay from "../../components/geriactive/games/wordOfTheDay/WordOfTheDay";
import PhraseSort from "../../components/geriactive/games/phraseSort/PhraseSort";
import LetterScramble from "../../components/geriactive/games/letterScramble/LetterScramble";
import MathCorrect from "../../components/geriactive/games/mathCorrect/MathCorrect";
import MathCorrectChoice from "../../components/geriactive/games/mathCorrect/MathCorrectChoice";
import CountTiles from "../../components/geriactive/games/countTiles/CountTiles";
import OddOneOut from "../../components/geriactive/games/oddOneOut/OddOneOut";
import ColorCount from "../../components/geriactive/games/colorCount/ColorCount";
import ShoppingList from "../../components/geriactive/games/shoppingList/ShoppingList";
import MemoryMatch from "../../components/geriactive/games/memoryMatch/MemoryMatch";
import PhoneRecall from "../../components/geriactive/games/phoneRecall/PhoneRecall";
import PickNew from "../../components/geriactive/games/pickNew/PickNew";
import Sequences from "../../components/geriactive/games/sequences/Sequences";
import Bingo from "../../components/geriactive/games/bingo/Bingo";
import CategorySortsSelect from "../../components/geriactive/games/categorySortsSelect/CategorySortsSelect";
import CategorySortsImages from "../../components/geriactive/games/categorySortsImages/CategorySortsImages";
import WordSearch from "../../components/geriactive/games/wordSearch/WordSearch";
import ExternalGames from "../../components/geriactive/games/externalGames/ExternalGames";

// Shared by geriactiveRoutes and plmRoutes. PLM users reach these through the
// "Just for Fun" tile.
const gameRoutes = [
  <Route
    path="games/category-sorts"
    key="category-sorts"
    element={<CategorySorts />}
  />,
  <Route
    path="games/category-sorts-select"
    key="category-sorts-select"
    element={<CategorySortsSelect />}
  />,
  <Route
    path="games/category-sorts-images"
    key="category-sorts-images"
    element={<CategorySortsImages />}
  />,
  <Route path="games/high-low" key="high-low" element={<HighLow />} />,
  <Route path="games/finish-line" key="finish-line" element={<FinishLine />} />,
  <Route path="games/word-hunter" key="word-hunter" element={<WordHunter />} />,
  <Route path="games/wotd" key="wotd" element={<WordOfTheDay />} />,
  <Route path="games/phrase-sort" key="phrase-sort" element={<PhraseSort />} />,
  <Route path="games/word-search" key="word-search" element={<WordSearch />} />,
  <Route path="games/count-tiles" key="count-tiles" element={<CountTiles />} />,
  <Route path="games/odd-one-out" key="odd-one-out" element={<OddOneOut />} />,
  <Route path="games/color-count" key="color-count" element={<ColorCount />} />,
  <Route path="games/sequences" key="sequences" element={<Sequences />} />,
  <Route path="games/pick-new" key="pick-new" element={<PickNew />} />,
  <Route path="games/bingo" key="solo-bingo" element={<Bingo />} />,
  // <Route
  //   path="games/multi-bingo/create-room"
  //   key="create-bingo-room"
  //   element={<CreateBingoRoom />}
  // />,
  // <Route
  //   path="games/multi-bingo/"
  //   key="multi-bingo-room"
  //   element={<MultiBingo />}
  // />,
  // <Route
  //   path="games/bingo-selection"
  //   key="bingo-selection"
  //   element={<BingoSelection />}
  // />,
  <Route
    path="games/external-games"
    key="external-games"
    element={<ExternalGames />}
  />,
  <Route
    path="games/phone-recall"
    key="phone-recall"
    element={<PhoneRecall />}
  />,
  <Route
    path="games/memory-match"
    key="memory-match"
    element={<MemoryMatch />}
  />,
  <Route
    path="games/shopping-list"
    key="shopping-list"
    element={<ShoppingList />}
  />,
  <Route
    path="games/math-correct"
    key="math-correct"
    element={<MathCorrect />}
  />,
  <Route
    path="games/math-correct-choice"
    key="math-correct-choice"
    element={<MathCorrectChoice />}
  />,
  <Route
    path="games/letter-scramble"
    key="letter-scramble"
    element={<LetterScramble />}
  />,
  <Route path="games" key="games" element={<Games />} />,
  <Route path="/quiz-show" key="quiz-show" element={<QuizShow />} />,
];

export default gameRoutes;
